import React, { Dispatch, SetStateAction, useState } from 'react';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { ExpenseDA } from '../../services/admin/expense.service';
import { GlobalSwal } from '../../styles/swal.style';
import { Company } from '../../models/company.model';
import { Expense } from '../../models/expense.model';
import { Error } from '../../models/error.model';
import { modalHide } from '../../utils/modal.util';
import { getError } from '../../languages/translations/response';
import { errorWebHandler } from '../../scripts/error.web.handler.script';

import AppLoading from '../Loading';

export interface AppModalExpenseUpdateInvalidateProps {
  companyForUser: Company | null
  expense: Expense | null,
  setExpense: Dispatch<SetStateAction<Expense | null>>
};

let errorResponse: Error, expenseResponse: Expense;

const AppModalExpenseUpdateInvalidate: React.FunctionComponent<AppModalExpenseUpdateInvalidateProps> = ({companyForUser, expense, setExpense}) => {
  const {lang} = StateLanguage()

  const [loadIndicator, setLoadIndicator] = useState('off')

  const submitExpenseInvalidate = async () => {
    setLoadIndicator('on')

    if (companyForUser && expense) {
      await ExpenseDA.putExpenseStatus(companyForUser.id, expense.id, null, null, null, null).then( (response) => {
        if (response.status === 200) {
          expenseResponse = response.data
          setExpense(expenseResponse)

          GlobalSwal.fire({
            title: lang.labels.successfullyUpdatedStatus,
            text: lang.labels.actionCompletedReturningToPage,
            icon: 'success',
            showConfirmButton: false,
            timer: 2200
          }).then( () => {
            executeHideModalExpenseUpdateInvalidate()
          })
        } else {
          errorResponse = response.data

          GlobalSwal.fire({
            title: getError(errorResponse.code, lang.code, errorResponse.message),
            text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
            icon: 'error',
            showConfirmButton: false,
            timer: 2200
          })
        }
      }).catch( (error) => {
        errorWebHandler(lang, error)
      }).finally(() => {
        setLoadIndicator('off')
      })
    }
  }

  const executeHideModalExpenseUpdateInvalidate = () => {
    modalHide('modal-expense-update-invalidate')
  }

  return (
    <div id="modal-expense-update-invalidate" className="modal fade" tabIndex={-1} aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="text-capitalize">{lang.labels.invalidateExpense}</h2>
          </div>
          <div className="modal-body">
            { expense
              ?
              <div className="text-justify fw-semibold">
                {lang.labels.ifYouInvalidateExpense}
                <strong className=" ms-1">{expense.expense_number}</strong>
                {lang.labels.theAssociatedAccountingEntriesWillBeDeletedExpense}
                <br /><br />
                {lang.labels.toPerformAnySubsequentActionWithExpense}
              </div>
              :
              <AppLoading></AppLoading>
            }
          </div>
          <div className="modal-footer flex-center">
            <button className="btn btn-secondary mx-2" type="reset" onClick={executeHideModalExpenseUpdateInvalidate}>{lang.labels.noCancel}</button>
            <button className="btn btn-primary mx-2" type="button" data-kt-indicator={loadIndicator} onClick={submitExpenseInvalidate}>
              <span className="indicator-label">{lang.labels.yesInvalidate}</span>
              <span className="indicator-progress">
                {lang.labels.pleaseWait}
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
};

export default AppModalExpenseUpdateInvalidate;
